import type { CSSProperties, ReactNode } from 'react'

const PILL_COLORS = {
  terra: { bg: 'var(--terra-bg)', fg: 'var(--terra-ink)' },
  felt: { bg: 'var(--felt-bg)', fg: 'var(--felt-ink)' },
  gilt: { bg: 'var(--gilt-bg)', fg: 'var(--gilt-ink)' },
  plum: { bg: 'var(--plum-bg)', fg: 'var(--ink)' },
  slate: { bg: 'var(--slate-bg)', fg: 'var(--ink-2)' },
} as const

export type PillProps = {
  children: ReactNode
  color?: keyof typeof PILL_COLORS
  icon?: ReactNode
  style?: CSSProperties
}

export const Pill = ({ children, color = 'slate', icon, style }: PillProps) => {
  const c = PILL_COLORS[color]
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        fontFamily: 'var(--font-display)',
        fontWeight: 500,
        fontSize: 11,
        color: c.fg,
        background: c.bg,
        borderRadius: 3,
        padding: '2px 7px',
        letterSpacing: 0.1,
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {icon}
      {children}
    </span>
  )
}
